import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Datetime from 'react-datetime';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';

import MaintenanceTaskList from './task-list';
import MaintenanceTaskImport from './task-import';
import MaintenanceGeneralTaskView from './task-general-view';
import MaintenanceSpecificTaskView from './task-specific-view';
import MaintenanceTaskAdd from './task-general-add';
import MaintenanceServices from './services';

import import_export_icon from 'assets/img/import-export-arrows.svg';

const CHILD_KEYS = {
  SCHEDULE_LIST: 'schedule-list',
  SCHEDULE_ADD: 'schedule-add',
  SCHEDULE_VIEW: 'schedule-view',
  NEW_BUTTON: 'new-button',
  BREADCRUMB: 'bread-crumbs'};

const SCREENS = {
  LIST: [CHILD_KEYS.SCHEDULE_LIST, CHILD_KEYS.NEW_BUTTON],
  ADD: [CHILD_KEYS.SCHEDULE_ADD, CHILD_KEYS.BREADCRUMB],
  VIEW: [CHILD_KEYS.SCHEDULE_VIEW, CHILD_KEYS.BREADCRUMB]
};

const TASK_TYPE = {
  GENERAL: 0,
  SPECIFIC: 1
};

export class MaintenanceTasks extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    projectId: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.maintenanceServices = new MaintenanceServices(this.props.dispatch);

    this.state = {
      activeScreen: SCREENS.LIST,
      showImportTaskModal: false,
      selectedItem: {},
      activeTabKey: TASK_TYPE.GENERAL
    };
  }

  // user events
  switchScreen= (screenKey) => {
    this.setState({activeScreen: screenKey});
  }
  // end user events

  // navigators
  goToEditScreen = (item) => {
    this.setState({selectedItem: item}, () => this.switchScreen(SCREENS.VIEW));
  }

  goToAddScreen = () => {
    this.switchScreen(SCREENS.ADD);
  }

  goToListScreen = () => {
    this.switchScreen(SCREENS.LIST);
  }

  goToMaintenanceSchedule() {
    this.props.history.push({
      pathname: this.props.history.location.pathname,
      search: 'toolSelection=lotTools&lotTab=maintenance-schedule'
    });
  }

  showImportTaskModal = () => {
    this.setState({showImportTaskModal: true});
  }

  hideImportTaskModal = () => {
    this.setState({showImportTaskModal: false});
    this.maintenanceServices.getTaskList(this.props.projectId, this.state.activeTabKey);
  }
  // end navigators

  // helpers
  saveActiveTabKey = (activeTabKey) => {
    this.setState({ activeTabKey: activeTabKey});
  }

  getBreadcrumbsInfo() {
    if (this.state.activeScreen === SCREENS.ADD) {
      return [
        {title: 'Maintenance Tasks', url: '/', onCustomAction: this.goToListScreen},
        {title: 'Add New Maintenance Task', url: ''}
      ];
    }
    else if (this.state.activeScreen === SCREENS.VIEW) {
      return [
        {title: 'Maintenance Tasks', url: '/', onCustomAction: this.goToListScreen},
        {title: this.state.selectedItem.name, url: ''}
      ];
    }

    return [];
  }
  // end helpers

  // services
  // end services

  // renders
  renderScreen = (screenKey, isSpecificTask) => {
    switch (screenKey) {
      case CHILD_KEYS.SCHEDULE_LIST:
        return <MaintenanceTaskList
          projectId={this.props.projectId}
          activeTabKey={this.state.activeTabKey}
          goToEditScreen={this.goToEditScreen}
          goToAddScreen={this.goToAddScreen}
          onSelectTab={this.saveActiveTabKey} />;

      case CHILD_KEYS.SCHEDULE_ADD:
        return (
          <div className='row'>
            <div className='col-md-8'>
              <MaintenanceTaskAdd
                projectId={this.props.projectId}
                onCancel={this.goToListScreen} />
            </div>
          </div>
        );

      case CHILD_KEYS.SCHEDULE_VIEW:
        if (isSpecificTask) {
          return (
            <div className='row'>
              <div className='col-md-8'>
                <MaintenanceSpecificTaskView
                  inventoryItem={this.state.selectedItem.inventoryItem}
                  projectId={this.props.projectId}
                  id={this.state.selectedItem.id}
                  onCancel={this.goToListScreen} />
              </div>
            </div>
          );
        }
        else {
          return (
            <div className='row'>
              <div className='col-md-8'>
                <MaintenanceGeneralTaskView
                  projectId={this.props.projectId}
                  id={this.state.selectedItem.id}
                  onCancel={this.goToListScreen} />
              </div>
            </div>
          );
        }

      default: null;
    }

    return null;
  }

  render() {
    return (
      <React.Fragment>
        <div style={{padding: '15px 0'}}>
          {
            this.state.activeScreen.includes(CHILD_KEYS.NEW_BUTTON) &&
              <React.Fragment>
                <div>
                  <img className='icon' style={{width: '18px'}} src={import_export_icon} />
                  <a href='#' onClick={this.showImportTaskModal}> Import from Suggested Maintenance Tasks</a>
                  {/* <div style={{display: 'inline-block', marginLeft: '10px'}}>
                    <Datetime
                      timeFormat={false}
                      dateFormat='MM/DD/YYYY'
                      value={localStorage['TODAY'] || (new Date())}
                      onChange={value => localStorage.setItem('TODAY', Moment(value).format('MM/DD/YYYY'))} />
                  </div> */}
                </div>

              </React.Fragment>
          }
          {
            this.state.activeScreen.includes(CHILD_KEYS.BREADCRUMB) &&
            <Breadcrumb breadcrumbs={this.getBreadcrumbsInfo()} />
          }
          {
            this.state.activeScreen.includes(CHILD_KEYS.SCHEDULE_LIST) &&
              this.renderScreen(CHILD_KEYS.SCHEDULE_LIST)
          }
          {
            this.state.activeScreen.includes(CHILD_KEYS.SCHEDULE_ADD) &&
            this.renderScreen(CHILD_KEYS.SCHEDULE_ADD)
          }
          {
            this.state.activeScreen.includes(CHILD_KEYS.SCHEDULE_VIEW) &&
            this.renderScreen(CHILD_KEYS.SCHEDULE_VIEW, this.state.selectedItem.inventoryItem)
          }
          {
            this.state.showImportTaskModal &&
            <MaintenanceTaskImport
              projectId={this.props.projectId}
              closeModal={this.hideImportTaskModal} />
          }
        </div>
      </React.Fragment>
    );
  }
  // end renders
}

export default withRouter(connect()(MaintenanceTasks));



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task.js